
import { Inject, Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { DomainObjectRepo } from '../../noizu/domain-object-repo';
import { FirebaseAuthService }        from '../../noizu/services/firebase-auth.service';
import { DataBatchesEntity }      from '../../entities/data-batches.entity';
import { AppengineRepo }      from '../appengine.repo';

@Injectable()
export class DataBatchesRepo extends AppengineRepo {
  public _kind = "batches";
  public _singular = "batches";

  constructor(@Inject(HttpClient) client: HttpClient, @Inject(FirebaseAuthService) auth: FirebaseAuthService) {
    super(client, auth);
  }

  entity(record) {
    return new DataBatchesEntity(this.client, this.auth, record)
  }
}
